import { SDate } from '@summit/core';
import { Dayjs } from 'dayjs';
import { EboTenantItemTo } from '../../base-classes/ebo-tenant-item-to';
import { Terminal } from '../../places/terminal/terminal';
import { ServiceArea } from '../service-area/service-area';
import { Company } from './company';

export class Contract extends EboTenantItemTo {
  companyID: string;
  company?: Company;
  externalCompanyID?: string;
  externalCompany?: Company;
  description: string;
  startDate?: Dayjs;
  endDate?: Dayjs;
  isActive: boolean;
  terminalId?: string;
  terminal?: Terminal;
  serviceAreaId?: string;
  serviceArea?: ServiceArea;
  settlements?: any[]; // CompanySettlement collection

  constructor(jsonData?: Partial<Contract>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.startDate) this.startDate = SDate.newUtc(jsonData.startDate);
      if (jsonData.endDate) this.endDate = SDate.newUtc(jsonData.endDate);
      if (jsonData.company) this.company = new Company(jsonData.company);
      if (jsonData.externalCompany) this.externalCompany = new Company(jsonData.externalCompany);
      if (jsonData.terminal) this.terminal = new Terminal(jsonData.terminal);
      if (jsonData.serviceArea) this.serviceArea = new ServiceArea(jsonData.serviceArea);
    }
    this.isActive = jsonData?.isActive ?? true;
  }

  toShortString(): string {
    return this.name || 'Unknown';
  }
}
